<div [class.content-unavailable]="isContentAvailable === false">
  <ng-content></ng-content>
</div>
